import { render, staticRenderFns } from "./TabDescription.vue?vue&type=template&id=684c4ec9&"
import script from "./TabDescription.vue?vue&type=script&lang=js&"
export * from "./TabDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports